import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import { DataLayer, Feature, Marker } from 'google-react-maps';
import { emit } from 'utils';

class MapCreatorDataLayer extends React.Component {
  constructor(props) {
    super(props);

    this.handleCreateFeature = this.handleCreateFeature.bind(this);
    this.handleUpdateFeature = this.handleUpdateFeature.bind(this);
    this.generateInfoWindow = this.generateInfoWindow.bind(this);
  this.getDrawingMode = this.getDrawingMode.bind(this);
  }

  handleCreateFeature(feature, map_id) {
    if(feature.geometry.type == 'Point') {
  		const { current_marker_type } = this.props.mapCreator;
  		feature.properties = { ...(feature.properties || {}), icon_file: current_marker_type.file_data._id };
  	}
    emit('create-map-feature', { data: { feature, map_id } })
    .catch(this.props.notify)
    .finally(() => {
      this.props.setMapCreatorProperties({
        show_marker_editor_icon_modal: false,
        show_marker_editor_info_window_modal: false,
        tmp_info_window_image_file: null
      });
    });
  }
  handleUpdateFeature(feature) {
    const { _id: map_id } = this.props.mapCreator.current_map;
    this.props.updateCurrentMapFeature(feature, map_id);
  }
  generateInfoWindow(feature) {
    //TODO: Clean up the poor data structure here.
    const { info_window_text, info_window_image_file } = feature.properties;
    if(!info_window_text && !info_window_image_file) {
      return null;
    }

    return (
      `<div class="panel">
        <div class="panel-body">
          ${info_window_text ? (
          `<div class="row">
            <div class="col-xs-12 col-md-12">
              <h5>${info_window_text}</h5>
            </div>
          </div>`
          ) : ''}
          ${info_window_image_file && info_window_image_file.url ? (
            `<div class="row">
              <div class="col-md-12 col-xs-12 map-creator-info-window-image">
                <img src="${info_window_image_file.url}">
              </div>
            </div>`
          ) : ''}
        </div>
      </div>`
    );
  }
  getDrawingMode(map_id) {
    const { current_map, drawing_mode, current_marker_type } = this.props.mapCreator;
    if(current_map && current_map._id == map_id) {
      switch(drawing_mode) {
        case 'Polygon': {
          return drawing_mode;
        }
        case 'Point': {
          return current_marker_type == null ? null : 'Point';
        }
        default: {
          return null;
        }
      }
    }
  }

  render() {
    const {
      maps_list,
      current_map,
      current_feature,
      current_feature_saved,
      hidden_maps,
      swath_opacity,
      drawing_mode,
      hidden_features
    } = this.props.mapCreator;
    return (
      <div>
        {maps_list
        .filter(map => !hidden_maps.includes(map._id))
        .map(map => (
          <DataLayer
            fillOpacity={swath_opacity}
            drawingMode={this.getDrawingMode(map._id)}
            zIndex={1}
            visible={true}
            key={map._id}
            onCreate={f => this.handleCreateFeature(f, map._id)}
            map={this.props.map}
            maps={this.props.maps}
            >
            {map.features
            .filter(feature => !hidden_features.includes(feature.properties._id))
            .map(feature => {
              if(feature.geometry.type == 'Polygon') {
                return (
                  <Feature
                    fastEditing={true}
                    onChange={this.handleUpdateFeature}
                    onRightClick={() => this.props.setCurrentMapCreatorFeature(feature.properties._id, map._id)}
                    onClick={() => {}}
                    editable={current_feature && current_feature.properties._id == feature.properties._id}
                    id={feature.properties._id}
                    geoJson={feature}
                    key={`${map._id}-${feature.properties._id}`}
                  />
                )
              }
              else {
                if(
                  current_feature && current_feature_saved &&
                  feature.properties._id == current_feature._id &&
                  current_feature.properties._id == current_feature_saved.properties._id
                ) {
                  feature = current_feature_saved;
                }

                const coordinates = feature.geometry.coordinates[0];
                const lat_lng = new this.props.maps.LatLng({ lng: coordinates[0], lat: coordinates[1] });
                return (
                  <Feature
                    key={feature.properties._id}
                    onRightClick={() => this.props.setCurrentMapCreatorFeature(feature.properties._id, map._id)}
                    onChange={this.handleUpdateFeature}
                    icon={(feature.properties.icon_file || {}).url}
                    draggable={current_feature && current_feature.properties._id == feature.properties._id && current_feature.properties.draggable}
                    geoJson={feature}
                    infoWindow={this.generateInfoWindow(feature)}
                    id={feature.properties._id}
                  />
                )
              }
            })
          }
          </DataLayer>
        ))}
      </div>
    );
  }
}

export default mapCreatorConnect(MapCreatorDataLayer);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-creator-data-layer.js